'use client';

import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';

// Dynamic import to avoid SSR issues with Lottie
const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

import animationData from './about_hero.json';

const AboutScene = () => {
    // Fade in effect using state to ensure it works reliably
    const [isLoaded, setIsLoaded] = React.useState(false);

    React.useEffect(() => {
        setIsLoaded(true);
    }, []);

    return (
        <div
            className={`w-full h-full flex items-center justify-center transition-opacity duration-1000 ease-out ${isLoaded ? 'opacity-100' : 'opacity-0'}`}
        >
            <Lottie
                animationData={animationData}
                loop={true}
                autoplay={true}
                style={{ width: '100%', height: '100%' }}
            />
        </div>
    );
};

export default AboutScene;
